import { useLayoutEffect } from "react";
import { Box, Typography } from "@mui/material";

import { useCore } from "../../../shared/hooks/use-core";
import { OrdersList } from "./OrdersList";

export default function Orders() {
	const { setTitleBar, setPathTitleBar } = useCore();

	useLayoutEffect(() => {
		setTitleBar("Pedidos Web");
		setPathTitleBar(undefined);
	}, [setTitleBar, setPathTitleBar]);

	return (
		<Box>
			<Typography variant="h5">Lista de Pedidos</Typography>
			<Typography variant="body2" color="text.secondary">
				Acompanhe os pedidos gerados pelo site, filtre por período ou cliente e
				exporte para Excel.
			</Typography>

			<Box sx={{ mt: 3 }}>
				<OrdersList />
			</Box>
		</Box>
	);
}
